import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Row } from 'antd';
import { useHistory } from 'react-router-dom';

const ButtonGroup = Button.Group;

interface Props {
    title: string;
    actions: React.ReactChild[];
}

const PageHeader = (props: Props) => {
    const history = useHistory();

    return (
        <React.Fragment>
            <Row style={{ backgroundColor: '#fff', margin: '0' }} className="detail-top-row">
                <Col sm={24} lg={12}>
                    <div className="flex flex-row items-center">
                        <ArrowLeftOutlined onClick={history.goBack} />
                        <span>
                            {' '}
                            <strong className="ml-2">{props.title}</strong>
                        </span>
                    </div>
                </Col>
                <Col sm={24} lg={12} style={{ textAlign: 'right' }}>
                    <ButtonGroup>{props.actions}</ButtonGroup>
                </Col>
            </Row>
            <Row style={{ backgroundColor: '#fff', margin: 0 }}>
                <Divider style={{ marginBottom: 0 }} />
            </Row>

            <Divider className={'spacing'} />
        </React.Fragment>
    );
};

export default PageHeader;
